import React, { useCallback, useRef, useState } from 'react';

const PLACEHOLDER_SRC =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="1" height="1"%3E%3C/svg%3E';

const LazyImage = ({
  src,
  alt,
  className = '',
  style,
  width,
  height,
  loading = 'lazy',
  decoding = 'async',
  srcSet,
  sizes,
  onError,
  onLoad,
  id,
  role,
  referrerPolicy,
  fetchPriority,
  ...rest
}) => {
  const [hasError, setHasError] = useState(false);
  const errorHandledRef = useRef(false);

  const handleError = useCallback(
    (event) => {
      if (errorHandledRef.current) {
        return;
      }
      errorHandledRef.current = true;
      setHasError(true);
      onError?.(event);
    },
    [onError]
  );

  const imageClassName = [
    className,
    hasError ? 'bg-gray-200 object-contain' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <img
      src={hasError ? PLACEHOLDER_SRC : src}
      alt={alt}
      className={imageClassName}
      style={style}
      width={width}
      height={height}
      loading={loading}
      decoding={decoding}
      srcSet={hasError ? undefined : srcSet}
      sizes={sizes}
      onError={handleError}
      onLoad={onLoad}
      id={id}
      role={role}
      referrerPolicy={referrerPolicy}
      fetchPriority={fetchPriority}
      {...rest}
    />
  );
};

export default LazyImage;
